import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, UncontrolledTooltip, Input, Label, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
// FlatPickr
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import SimpleBar from "simplebar-react";
import { createEvent, getAllCountries, getAllEventCategory, getAllOrganizer } from "api";
import { getAuthUser, getCountryId, getUserRole } from "utils/storage";
import useCountryStore from "../../../store/countryStore";
import { useAutoSelectCountry } from "../../../hooks/useAutoSelectCountry";
import Select from "react-select";
import { eventDuration, eventTime } from "utils/constants";
import toast, { Toaster } from 'react-hot-toast';
import { Editor } from "react-draft-wysiwyg";
import { EditorState,convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


const CreateEvent = () => {

  //meta title
  document.title = "Create New Event | Eventox";
  const role = getUserRole();

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgStore, setImgStore] = useState([]);
  const [dropList, setDropList] = useState(false);
  const [active, setActive] = useState(0)

  const [organizerList, setOrganizerList] = useState([])
  const [categoryList, setCategoryList] = useState([])

  const [selectedOrganizer, setSelectedOrganizer] = useState(null)
  const [selectedEventTime, setSelectedEventTime] = useState(null)
  const [selectedEventDuration, setSelectedEventDuration] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedEventType, setSelectedEventType] = useState(null)
  const [selectedTicketType, setSelectedTicketType] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [otherFeesSelected, setOtherFeesSelected] = useState(true)
  const [selectedThumbImg, setSelectedThumbImg] = useState(null)
  const [selectedBannerImgDesktop, setSelectedBannerImgDesktop] = useState(null)
  const [selectedBannerImgMobile, setSelectedBannerImgMobile] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [onlineEventCategory, setOnlineEventCategory] = useState(null)
  const [paymentChannel, setPaymentChannel] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [countryList, setCountryList] = useState([])
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [ticketGrouping, setTicketGrouping] = useState(null)
  const [ticketStatus, setTicketStatus] = useState(null)
  const [requireOtherAttendees, setRequireOtherAttendees] = useState(false);
 const [isPreRegistrationRequired, setIsPreRegistrationRequired] = useState(false);






  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await getAllOrganizer();
        const respCategory = await getAllEventCategory();
        const countryResp = await getAllCountries();
        const countryOption = countryResp.map((country, index) => {
          return { value: country.countryId, label: country.countryName }
        })
        setCountryList(countryOption)


        const categoryOption = respCategory.map((cat, index) => {
          return { value: cat.categoryId, label: cat.categoryName }
        })
        const organizerOption = resp.map((org, index) => {
          return { 
            value: org.organizerId, 
            label: org.name,
            processingFee: org.processingFee,
            ticketFee: org.ticketFee,
            platformFee: org.platformFee,
            platformFeeType: org.platformFeeType
          }
        });
        setCategoryList(categoryOption)
        setOrganizerList(organizerOption)
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();

    return () => {

    }
  }, [])

  const handleAcceptedFiles = (files) => {
    const newImages = files?.map((file) => {
      return Object.assign(file, {
        priview: URL.createObjectURL(file),
      })
    })
    setSelectedFiles([...selectedFiles, ...newImages]);
  };

  const onEditorStateChange = (newEditorState) => {

    setEditorState(newEditorState);
    const rawContentState = convertToRaw(newEditorState.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);
    validation.setFieldValue('eventDescription', htmlContent)
    console.log("🚀 ~ onEditorStateChange ~ htmlContent:", htmlContent)

    console.log("🚀 ~ onEditorStateChange ~ rawContentState:", rawContentState)

  };
  //  img upload
  const handleImageChange = (event, filed) => {
    if (event.target.files[0].size > 2097152) {
      toast.error("File size should be less than 2MB");
    } else {
      event.preventDefault();
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onloadend = () => {
        if (filed === 'thumbImg') setSelectedThumbImg(reader.result);
        if (filed === 'bannerImgDesktop') setSelectedBannerImgDesktop(reader.result);
        if (filed === 'bannerImgMobile') setSelectedBannerImgMobile(reader.result);
        // setSelectedImage(reader.result);
        validation.setFieldValue(filed, file)
      };
      reader.readAsDataURL(file);
    }
  };


  const handleClick = (item) => {
    const isItemInImgStore = imgStore.some((imgItem) => imgItem.id === item.id);
    setActive(item.id)
    if (!isItemInImgStore) {
      const newData = [...imgStore, item];
      setImgStore(newData);
      validation.setFieldValue('assignedto', newData)
    } else {
      const newData = imgStore.filter((imgItem) => imgItem.id !== item.id)
      setImgStore(newData);
      validation.setFieldValue('assignedto', newData)
    }
  }

  // validation
  const validation = useFormik({
    initialValues: {
      eventName: '',
      eventDescription: '',
      shortDescription:'',
      thumbImg: '',
      bannerImgDesktop: '',
      bannerImgMobile: '',
      eventLocation: '',
      categoryId: '',
      organizerId: '',
      ticketType: '',
      paymentChannel: '',
      paymentUrl: '',
      eventType: '',
      onlineEventType: '',
      eventStatus: '',
      eventDate: '',
      endDate: '',
      eventTime: '',
      eventDuration: '',
      createdBy: 'Admin',
      eventVenue: '',
      eventAddress1: '',
      eventAddress2: '',
      eventCountry: 0,
      eventState: '',
      eventCity: '',
      eventZip: '',
      processingFee:'',
      ticketFee:'',
      platformFee:'',
      platformFeeType:'per_booking',
      showOtherFees:true,
      ticketGrouping:'single',
      ticketStatus:'',
      isPreRegistrationRequired:false,




    },
    validationSchema: Yup.object({
      eventName: Yup.string().required("Please Enter Your Event Name"),
      eventDescription: Yup.string().required("Please Enter Your Event Desc"),
      shortDescription: Yup.string().required("Please Enter Your Event Short Desc"),
      thumbImg: Yup.string().required("Please Select Thumb Image"),
      
      organizerId: Yup.string().required("Please Select Organizer"),
      
      
      eventDate: Yup.string().required("Please Select Event Date"),
      

      eventCountry: Yup.string().required("Please Select Event Country"),
      




    }),
    onSubmit: async (values) => {
      console.log(values);
      setIsLoading(true);
      const showOtherFees = values.processingFee === 0 && values.ticketFee === 0 ? false : values.showOtherFees;
      let formData = new FormData();
      formData.append("eventName", values.eventName);
      formData.append("eventDescription", values.eventDescription);
      formData.append("shortDescription", values.shortDescription);
      formData.append("thumbImg", values.thumbImg);
      formData.append("bannerImgDesktop", null);
      formData.append("bannerImgMobile", null);
      formData.append("eventLocation", values.eventLocation);
      formData.append("categoryId",0);
      formData.append("organizerId", values.organizerId);
      formData.append("ticketType", 'paid');
      formData.append("paymentChannel", 'our');
      formData.append("paymentUrl", '');
      formData.append("eventType",'offline');
      formData.append("onlineEventType", 'offline');
      formData.append("eventStatus", 'active');
      formData.append("eventDate", values.eventDate);
      formData.append("eventTime", values.eventTime);
      formData.append("eventDuration", '');
      formData.append("createdBy", 'admin');
      formData.append("eventVenue",values.eventLocation);
      formData.append("eventAddress1",values.eventLocation);
      formData.append("eventCountry", values.eventCountry);
      formData.append("processingFee",values.processingFee);
      formData.append("ticketFee",values.ticketFee);
      formData.append("platformFee",values.platformFee);
      formData.append("platformFeeType",values.platformFeeType);
      formData.append("showOtherFees", showOtherFees);
      formData.append("ticketStatus", 'open');
      formData.append("ticketGrouping", 'single_with_grouping');
      formData.append("isPreRegistrationRequired", values.isPreRegistrationRequired);
      formData.append("absorbFees", "attendee");
      selectedFiles.forEach((file) => {
        formData.append("otherImages", file);
      });
      


      console.log(formData);
      try {
        const eventResponse = await createEvent(formData);
        resetFields();
        toast.success(`${values.eventName} event created Successfully`);
      } catch (error) {
        console.log(error);
        toast.error(`Failed to create ${values.eventName} event.${error.message}`);
      } finally {
        setIsLoading(false);
      }

      console.log("🚀 ~ onSubmit:async ~ eventResponse:", eventResponse)

    }
  });

  useAutoSelectCountry({
    countryList: countryList,
    setSelectedCountry: setSelectedCountry,
    setFieldValue: validation.setFieldValue,
    fieldName: "eventCountry"
  });

  const resetFields = () => {
    validation.resetForm();
    setSelectedThumbImg(null);
    setSelectedBannerImgDesktop(null);
    setSelectedBannerImgMobile(null);
    setSelectedCategory(null);
    setSelectedOrganizer(null);
    setSelectedTicketType(null);
    setSelectedStatus(null);
    setSelectedEventType(null);
    setPaymentChannel(null);
    setOnlineEventCategory(null);
    setSelectedCountry(null);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Events" breadcrumbItem="Create New Event" />
          <Form id="createproject-form" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <input type="hidden" className="form-control" id="formAction" name="formAction" defaultValue="add" />
                    <input type="hidden" className="form-control" id="project-id-input" />
                    <div className="mb-3">
                      <Label htmlFor="projectname-input">Event Name</Label>
                      <Input
                        id="eventName"
                        name="eventName"
                        type="text"
                        placeholder="Enter Event Name..."
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.eventName || ""}
                      />
                      {validation.touched.eventName && validation.errors.eventName ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.eventName}</FormFeedback>
                      ) : null}

                    </div>
                    <div className="mb-3">
                      <Label htmlFor="projectdesc-input">Event Description</Label>
                      
                       <Editor
                              toolbarClassName="toolbarClassName"
                              wrapperClassName="wrapperClassName"
                              editorClassName="editorClassName"
                              placeholder="Place Your Content Here..."
                              name="eventDescription"
                              onEditorStateChange={onEditorStateChange}
                             
                            />
                      {validation.touched.eventDescription && validation.errors.eventDescription ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.eventDescription}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                    <Label htmlFor="projectdesc-input">Short Description</Label>
                      <Input as="textarea"
                        id="shortDescription"
                        rows={15}
                        multiple={true}
                        name="shortDescription"
                        placeholder="Enter Event Short Description..."
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.shortDescription || ""}
                      />
                       {validation.touched.shortDescription && validation.errors.shortDescription ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.shortDescription}</FormFeedback>
                      ) : null}
                    </div>

                   
                    <Row>
                      <Col lg={4}>
                      <div className="mb-3">
                      <Label className="form-label">Thumbnail Image</Label>
                      <p className="text-muted m-b-15">The Image should be min 561 × 691 pixel</p>

                      <div className="">
                        <div className="position-relative d-inline-block">
                          <div className="position-absolute bottom-0 end-0">
                            <Label htmlFor="project-image-input1" className="mb-0" id="projectImageInput">
                              <div className="avatar-xs">
                                <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                                  <i className="bx bxs-image-alt"></i>
                                </div>
                              </div>
                            </Label>
                            <UncontrolledTooltip placement="right" target="projectImageInput">
                              Select Image
                            </UncontrolledTooltip>
                            <input className="form-control d-none" id="project-image-input1" type="file" accept="image/png, image/gif, image/jpeg" onChange={(e) => handleImageChange(e, 'thumbImg')} />
                          </div>
                          <div className="avatar-lg upload-image-container">
                            <div className="avatar-title bg-light">
                              <img src={selectedThumbImg || ''} id="projectlogo-img" alt="" className="avatar-md h-auto" />
                            </div>
                          </div>
                        </div>
                        {validation.touched.thumbImg && validation.errors.thumbImg ? (
                          <FormFeedback type="invalid" className="d-block">{validation.errors.thumbImg}</FormFeedback>
                        ) : null}
                      </div>
                    </div>
                      </Col>
                      
                    </Row>
                    <div className="mb-3">
                      <Label htmlFor="projectname-input">Organizer</Label>
                      <Select
                        value={selectedOrganizer}
                        placeholder="Select Organizer"
                        onChange={(data) => {
                          setSelectedOrganizer(data)
                          validation.setFieldValue("organizerId", data.value)
                          validation.setFieldValue("processingFee", data.processingFee ?? "")
                          validation.setFieldValue("ticketFee", data.ticketFee ?? "")
                          validation.setFieldValue("platformFee", data.platformFee ?? "")
                          validation.setFieldValue("platformFeeType", data.platformFeeType || "per_booking")
                        }}
                        options={organizerList}
                        width="100%"
                        className="select2-selection"
                      />
                      {validation.touched.organizerId && validation.errors.organizerId ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.organizerId}</FormFeedback>
                      ) : null}


                    </div>
                    <div className="mb-3">
                      <Label htmlFor="projectname-input">Event Category</Label>
                      <Select
                        value={selectedCategory}
                        placeholder="Select Category"
                        onChange={(data) => {
                          setSelectedCategory(data)
                          validation.setFieldValue("categoryId", data.value)

                        }}
                        options={categoryList}
                        width="100%"
                        className="select2-selection"
                      />
                      {validation.touched.categoryId && validation.errors.categoryId ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.categoryId}</FormFeedback>
                      ) : null}


                    </div>
                    <div className="mb-3">
                      <Label htmlFor="project-status-input">Event Date</Label>
                      <FlatPickr
                        className="form-control d-block"
                        id="orderdate"
                        name="eventDate"
                        placeholder="Select date"
                        options={{
                          mode: "single",
                          dateFormat: 'Y-m-d',
                        }}
                        onChange={(customerdate) => validation.setFieldValue("eventDate", moment(customerdate[0]).format("YYYY-MM-DD"))}
                        value={validation.values.eventDate || ''}
                      />
                      {validation.errors.eventDate && validation.touched.eventDate ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.eventDate}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="endDate"> End Date</Label>

                      <FlatPickr
                        className="form-control d-block"
                        id="endDate"
                        name="endDate"
                        placeholder="Select end date"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d",
                          minDate: validation.values.eventDate || "today"
                        }}
                        onChange={(date) =>
                          validation.setFieldValue(
                            "endDate",
                            moment(date[0]).format("YYYY-MM-DD")
                          )
                        }
                        value={validation.values.endDate || ""}
                      />

                      {validation.errors.endDate && validation.touched.endDate ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.endDate}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="project-status-input">Event Time</Label>
                      <Select
                        value={selectedEventTime}
                        placeholder="Select Time"
                        onChange={(data) => {
                          setSelectedEventTime(data)
                          validation.setFieldValue("eventTime", data.value)
                        }}
                        options={eventTime}
                        width="100%"
                        className="select2-selection"
                      />
                      {validation.touched.eventTime && validation.errors.eventTime ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.eventTime}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                        <Label htmlFor="projectname-input">Event Location</Label>
                        <Input
                          id="projectname"
                          name="eventLocation"
                          type="text"
                          placeholder="Enter Location..."
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.eventLocation || ""}
                        />
                        {validation.touched.eventLocation && validation.errors.eventLocation ? (
                          <FormFeedback type="invalid" className="d-block">{validation.errors.eventLocation}</FormFeedback>
                        ) : null}

                      </div>
                    <div className="mb-3">
                        <Label htmlFor="projectname-input">Country</Label>
                        {role === 5 ? (
                          <Input
                            type="text"
                            value={selectedCountry?.label || ""}
                            disabled
                            className="form-control"
                          />
                        ) : (
                        <Select
                          value={selectedCountry}
                          placeholder="Select country"
                          onChange={(data) => {
                            setSelectedCountry(data)
                            validation.setFieldValue("eventCountry", data.value)

                          }}
                          options={countryList}
                          width="100%"
                          className="select2-selection"
                        />
                        )}
                        {validation.touched.eventCountry && validation.errors.eventCountry ? (
                          <FormFeedback type="invalid" className="d-block">{validation.errors.eventCountry}</FormFeedback>
                        ) : null}


                      </div>
                      <div className="mb-3">
                        <Label htmlFor="projectname-input">Processing Fee</Label>
                        <Input
                          id="processingFee"
                          name="processingFee"
                          type="text"
                          placeholder="Enter zero if no processing fee"

                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.processingFee || ""}
                        />
                        {validation.touched.processingFee && validation.errors.processingFee ? (
                          <FormFeedback type="invalid" className="d-block">{validation.errors.processingFee}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="projectname-input">Ticket Fee</Label>
                        <Input
                          id="ticketFee"
                          name="ticketFee"
                          type="text"
                          placeholder="Enter zero if no ticket fee"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.ticketFee || ""}
                        />
                        {validation.touched.ticketFee && validation.errors.ticketFee ? (
                          <FormFeedback type="invalid" className="d-block">{validation.errors.ticketFee}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="projectname-input">Platform Fee</Label>
                        <Input
                          id="platformFee"
                          name="platformFee"
                          type="text"
                          placeholder="Enter platform fee"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.platformFee || ""}
                        />
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="platformFeeType">Platform Fee Type</Label>
                        <Select
                          value={[
                            { value: "per_booking", label: "Per Booking" },
                            { value: "per_ticket", label: "Per Ticket" },
                          ].find(o => o.value === validation.values.platformFeeType) || { value: "per_booking", label: "Per Booking" }}
                          placeholder="Select Fee Type"
                          onChange={(data) => {
                            validation.setFieldValue("platformFeeType", data.value)
                          }}
                          options={[
                            { value: "per_booking", label: "Per Booking" },
                            { value: "per_ticket", label: "Per Ticket" },
                          ]}
                          className="select2-selection"
                        />
                      </div>
                      <div className="mb-3">
                      <Label htmlFor="project-status-input">Show Processing & ticket fees in the checkout form and ticket  </Label>
                      <Select
                        value={otherFeesSelected}
                        placeholder="Select "
                        onChange={(data) => {
                          setOtherFeesSelected(data)
                          validation.setFieldValue("showOtherFees", data.value==='yes'?true:false)  

                        }}
                        options={[
                          { value: "yes", label: "Yes" },
                          { value: "no", label: "No" },

                        ]}
                        width="100%"
                        className="select2-selection"
                      />
                      {validation.touched.eventStatus && validation.errors.eventStatus ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.eventStatus}</FormFeedback>
                      ) : null}
                    </div>
                    {/*<div className="mb-3">
                      <Label htmlFor="projectname-input">Ticket Grouping</Label>
                      <Select
                        value={ticketGrouping}
                        placeholder="Select Ticket Grouping"
                        onChange={(data) => {
                          setTicketGrouping(data)
                          validation.setFieldValue("ticketGrouping", data.value)
                        }}
                        options={[
                          { value: "single", label: "Single" },
                          { value: "group", label: "Group" },

                        ]}
                        width="100%"
                        className="select2-selection"
                      />
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="projectname-input">Ticket Status</Label>
                      <Select
                        value={ticketStatus}
                        placeholder="Select Ticket Status"
                        onChange={(data) => {
                          setTicketStatus(data)
                          validation.setFieldValue("ticketStatus", data.value)
                        }}
                        options={[
                          { value: "open", label: "Active" },
                          { value: "close", label: "InActive" },

                        ]}
                        width="100%"
                        className="select2-selection"
                      />
                    </div> 
                    */}
                     <div className="mt-2 flex items-center space-x-4">
    <input
      type="checkbox"
      id="require-attendees"
      checked={requireOtherAttendees}
      onChange={(e) => {
        setRequireOtherAttendees(e.target.checked);
        validation.setFieldValue("requireOtherAttendees", e.target.checked);
      }}
      style={{ marginRight: '10px' }}
      className="form-checkbox"
    />
    <label htmlFor="require-attendees" className="text-sm">
      Require other attendees
                          </label>
                        </div>
                        <div className="mt-2 flex items-center space-x-4">
                        <input
                          type="checkbox"
                          id="is-pre-registration-required"
                          checked={isPreRegistrationRequired}
                          onChange={(e) => {
                            setIsPreRegistrationRequired(e.target.checked);
                            validation.setFieldValue("isPreRegistrationRequired", e.target.checked);
                          }}
                          style={{ marginRight: '10px' }}
                          className="form-checkbox"
                        />
                        <label htmlFor="is-pre-registration-required" className="text-sm">
                          Pre-registration required
                        </label>
                      </div>
                      <Col lg={12}>
                <div className="text-end mb-4">
                  <Button type="submit" disabled={isLoading} color="primary">{isLoading ? 'Creating event...' : 'Create Event'}</Button>
                </div>
              </Col>
                  
                
                  
                    </CardBody>
                  </Card>    
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateEvent;
